//POPOVER SCRIPT START
$(document).ready(function () {
    $('[data-toggle="popover"]').popover({
        trigger: 'hover',
        template: '<div class="popover info-popover" role="tooltip"> <div class="arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div>'
    });
});
//POPOVER SCRIPT END
